<template>
  <el-dialog
    :close-on-click-modal="false"
    title="车辆详情"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box :data="carData" :colNum="1">
        <span slot="sourceRegionName" slot-scope="prop">
          {{ prop.data.sourceRegionName }}-{{ prop.data.desRegionName }}
        </span>
        <span
          slot="plateNumber"
          slot-scope="prop"
          class="primary cur"
          @click="toCarDetail(prop.data.plateNumber)"
        >
          {{ prop.data.plateNumber }}
        </span>
        <span
          slot="orderId"
          slot-scope="prop"
          class="primary cur"
          @click="toOrderDetail(prop.data)"
        >
          {{ prop.data.orderId }}
        </span>
        <span
          slot="carDriverMan"
          slot-scope="prop"
          class="primary cur"
          @click="toDriverDetail(prop.data.carDriverId)"
        >
          {{ prop.data.carDriverMan }}
        </span>
        <span
          slot="copilotMan"
          slot-scope="prop"
          class="primary cur"
          @click="toDriverDetail(prop.data.copilotUserId)"
        >
          {{ prop.data.copilotMan }}
        </span>
      </qx-detail-box>
      <qx-detail-box :data="lineData" :colNum="1">
        <span slot="spareHour" slot-scope="prop">
          {{ prop.data.spareHour }}小时
        </span>
      </qx-detail-box>
      <p
        class="textCenter"
        v-if="originData.eventOrderInfo && originData.eventOrderInfo.orderId"
      >
        <span class="primary cur" @click="toTrack">轨迹回放</span>
      </p>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  invoiceApplyCarDetail,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      carData: {
        label: '车辆信息',
        tableData: {
          title: [
            {
              prop: 'customName',
              label: '客户名称',
            },
            {
              prop: 'sourceRegionName',
              label: '客户线路',
              slot: true,
            },
            {
              prop: 'vehicleClassName',
              label: '车辆类别',
            },
            {
              prop: 'plateNumber',
              label: '车牌号码',
              slot: true,
            },
            {
              prop: 'orderId',
              label: '订单号码',
              slot: true,
            },
            {
              prop: 'carDriverMan',
              label: '主驾信息',
              slot: true,
            },
            {
              prop: 'copilotMan',
              label: '副驾信息',
              slot: true,
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },
      lineData: {
        label: '运营信息',
        tableData: {
          title: [
            {
              prop: 'checkName',
              label: '盘点',
            },
            {
              prop: 'spareHour',
              label: '时间',
              slot: true,
            },
            {
              prop: 'markerPointAddress',
              label: '位置',
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.getDetailLoading = true;
      const res = await invoiceApplyCarDetail({
        agingType: 0,
        eventCode: item.eventCode,
        plateNumber: item.plateNumber,
      });
      this.carData.tableData.data = res.eventOrderInfo;
      this.lineData.tableData.data = {
        markerPointAddress: item.markerPointAddress,
        ...res.checkInfo,
      };
      this.originData = res;
      this.getDetailLoading = false;
    },
    toDriverDetail (userId) {
      this.dialogFormVisible = false;
      this.jump({
        label: '查看司机档案',
        url: `/manage/archives/driver/archives/detail?id=${userId}`,
        full: true,
      });
    },
    toCarDetail (plateNumber) {
      this.dialogFormVisible = false;
      this.jump({
        label: `查看车辆${plateNumber ? ('-' + plateNumber) : ''}`,
        url: `/manage/car/archives/my/detailRecord?plateNumber=${encodeURIComponent(plateNumber)}`,
        full: true,
      });
    },
    toOrderDetail (item) {
      // 取消遮罩层
      this.dialogFormVisible = false;
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toTrack () {
      if (!this.originData.eventOrderInfo) {
        return;
      }
      // 【2022042101】点击轨迹回放，取消遮罩层  --By liuyanming
      this.dialogFormVisible = false;
      this.jump({
        label: '轨迹查询',
        url: `/manage/operate/track/trackDetail?orderId=${this.originData.eventOrderInfo.orderId}`,
        full: true,
      });
    },
  },
};
</script>

<style>
</style>
